module.exports = __webpack_public_path__ + "img/bonus2.9b4a8711.png";